export type FormatNumberOptions = {
  minimumFractionDigits?: number;
  maximumFractionDigits?: number;
};

export const formatNumber = (
  number: number,
  lang: string,
  options: FormatNumberOptions = {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
): string => {
  if (isNaN(number)) {
    return '';
  }

  if (!lang) {
    return String(number ?? '');
  }

  const formatter = new Intl.NumberFormat(lang, {
    minimumFractionDigits:
      options.minimumFractionDigits ?? options.maximumFractionDigits ?? 2,
    maximumFractionDigits: options.maximumFractionDigits ?? 2,
  });

  return formatter.format(number ?? 0);
};
